



















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import AudienceListingDetail from '@ui/AudienceListing/AudienceListingDetail'
import AudienceListingPricingBox from '@partnerBuyComponents/AudienceListing/AudienceListingPricingBox'

settings =
  name: 'AudienceListingShowPage'

  resources:
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:listingId'

    audience_partnership:
      resourceName: 'audience_partnership'
      slug: 'audience_partnerships/:partnerToken'
      fetch: false

  vue:
    components: {
      LoadingIndicator,
      AudienceListingDetail,
      AudienceListingPricingBox,
    }

    computed:
      partnerToken: ->
        @$route.query.buy_partnership

      optionsForListingDetail: ->
        showPartnershipPricing: @audience_partnership?.show_pricing

      optionsForPricingBox: ->
        showPartnershipPricing: @audience_partnership?.show_pricing
        initialDate: dayjs().add(@audience_partnership?.earliest_listing, "days").toDate()

      actionsForAudienceListing: ->
        spaceIsBooked: @spaceIsBooked
        addBookingSpace: @addBookingSpaceToSession
        removeBookingSpace: @removeBookingSpaceFromSession

    mounted: ->
      @fetch 'audience_partnership' unless @audience_partnership

    methods:
      partnerBuy: -> { ...@getAppSession('partnerBuy', {}) }

      dayCellClassNames: ({ date, isPast, ...args }) ->
        ['disabled']

      # selectEventInstanceToSession: (ev, space) ->
      #   data = @partnerBuy()
      #   data.bookings ||= {}
      #   eventSetId = ev.event_set_id

      #   data.bookings[eventSetId] ||= {}
      #   data.bookings[eventSetId].event_ids ||= []
      #   return if data.bookings[eventSetId].event_ids.includes ev.id

      #   data.bookings[eventSetId].event_ids.push ev.id
      #   data.config = @bookingConfigForEvent ev
      #   @setAppSession 'partnerBuy', data

      spaceIsBooked: (space, pricingModel) ->
        data = @partnerBuy()
        listingId = @audience_listing.id
        s = data.bookings?[listingId]?.spaces?[space.name]
        # return false if pricingModel and s?.pricing_model isnt pricingModel
        isSameSpaceType = s?.space_type is space.type
        isSameSegment = s?.segment is space.segment
        isSameSpaceType and isSameSegment

      addBookingSpaceToSession: (space, pricingModel) ->
        listingId = @audience_listing.id
        data = @partnerBuy()
        data.bookings ||= {}
        data.bookings[listingId] ||= {}
        data.bookings[listingId].spaces = {}
        data.bookings[listingId].spaces[space.name] =
          pricing_model: pricingModel,
          space_type: space.type,
          space_size: space.size,
          segment: space.segment
        @setAppSession 'partnerBuy', data

      removeBookingSpaceFromSession: (spaceName) ->
        data = @partnerBuy()
        data.bookings ||= {}
        listingId = @audience_listing.id
        return unless data.bookings[listingId]
        delete data.bookings[listingId]?.spaces?[spaceName]
        isEmptySpaces = 0 is Object.values(data.bookings[listingId]?.spaces || {}).length
        delete data.bookings[listingId] if isEmptySpaces
        @setAppSession 'partnerBuy', data

export default VueOptions.vue settings
